import { render, staticRenderFns } from "./OikInfoModal.vue?vue&type=template&id=5e53be01&scoped=true&"
import script from "./OikInfoModal.vue?vue&type=script&lang=ts&"
export * from "./OikInfoModal.vue?vue&type=script&lang=ts&"
import style0 from "./OikInfoModal.vue?vue&type=style&index=0&id=5e53be01&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e53be01",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VExpansionPanels,VIcon,VSpacer,VTooltip})
